import { IsEmail, IsNotEmpty } from 'class-validator';

export class PasswordRemindRequestDto {
    @IsNotEmpty()
    @IsEmail()
    email: string;
}
